import useOmittedNumber from "@/hooks/useOmittedNumber";
import Link from "next/link";
import { FC } from "react";

type Props = {
  label: string;
  value: number;
  href: string;
};

const ValueItem: FC<Props> = ({ label, value, href }): JSX.Element => {
  const omittedNumber = useOmittedNumber(value);

  return (
    <div className="text-center space-y-8">
      <p className="font-bold">
        <Link href={href} prefetch={false} className="hover:underline">
          {omittedNumber}
        </Link>
      </p>
      <p className="font-bold text-secondary text-xs whitespace-nowrap">
        {label}
      </p>
    </div>
  );
};
export default ValueItem;
